import React from "react";
import { ReactComponent as BsBoxArrowRight } from "../../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const HistoryTable = ({tableData}) => {
  return (
    <div className="AllSalaryOutFlowTable">
      <div className="table-header">
        <ul
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            listStyleType: "none",
          }}
        >
          <li>Salary</li>
          <li>Total salary (INR)</li>
          <li>Gross salary (INR)</li>
          <li>Payment Mode</li>
          <li>Dispatched by</li>
        </ul>
      </div>
      <div className="table-body">
        {tableData.map((data, index) => {
          return (
            <ul
              key={data.receiptId}
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                listStyleType: "none",
                marginTop: "1rem",
              }}
            >
              <li>
                {data.receiptId}
                <br />{" "}
                <span
                  style={{ fontSize: "0.8rem", color: "var(--tableColor)" }}
                >
                  {data.time} {data.date}
                </span>
              </li>
              <li style={{ color: "var(--successGreen)" }}>
                {data.totalSalary}
              </li>
              <li style={{ color: "var(--successGreen)" }}>
                {data.grossSalary} <br />{" "}
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "var(--blueColor1)",
                  }}
                >
                  {data.month}
                </span>
              </li>
              <li style={{ color: "var(--tableColor)" }}>{data.paymentMode}</li>
              <li
                style={{
                  color: "var(--successGreen)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
              >
                {data.dispatchedBy}
                <br />
                <span
                  style={{
                    cursor: "pointer",
                    color: "var(--blueColor1)",
                    display: "flex",
                    gap: "0.5rem",
                  }}
                >
                  Receipts <BsBoxArrowRight />
                </span>
              </li>
            </ul>
          );
        })}
      </div>
    </div>
  );
};

export default HistoryTable;
